export default {
  text: '#111',
  primary: '#64ddff',
  secondary: '#292929',
  tertiary: '#64ddff',
  background: 'white',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
